var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddToDrive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_56647_61251",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_56647_61251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9998 21V18H14.9998V16H17.9998V13H19.9998V16H22.9998V18H19.9998V21H17.9998ZM5.6248 21.5C5.27481 21.5 4.9498 21.4083 4.6498 21.225C4.3498 21.0417 4.10814 20.8 3.9248 20.5L1.5748 16.4C1.39147 16.1 1.2998 15.7667 1.2998 15.4C1.2998 15.0333 1.39147 14.7 1.5748 14.4L7.9248 3.5C8.10814 3.16667 8.35397 2.91667 8.6623 2.75C8.97064 2.58333 9.2998 2.5 9.64981 2.5H14.3498C14.6998 2.5 15.029 2.58333 15.3373 2.75C15.6456 2.91667 15.8915 3.16667 16.0748 3.5L20.5498 11.175C20.2998 11.0917 20.0498 11.0375 19.7998 11.0125C19.5498 10.9875 19.2831 10.975 18.9998 10.975H18.5748C18.4415 10.975 18.2998 10.9917 18.1498 11.025L14.3498 4.5H9.64981L3.2998 15.4L5.6498 19.5H13.5498C13.7331 19.8833 13.9456 20.2417 14.1873 20.575C14.429 20.9083 14.7165 21.2167 15.0498 21.5H5.6248ZM7.2498 17L6.5248 15.725L11.0998 7.75H12.8998L15.4248 12.15C15.1248 12.3833 14.8623 12.6208 14.6373 12.8625C14.4123 13.1042 14.1998 13.375 13.9998 13.675L11.9998 10.2L9.2498 15H13.3498C13.2165 15.3333 13.1248 15.6625 13.0748 15.9875C13.0248 16.3125 12.9998 16.65 12.9998 17H7.2498Z",
    fill: "#5F5C71"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToDrive);
export default __webpack_public_path__ + "static/media/add_to_drive.d0bf53dbe3ebce720f689229fb6b839e.svg";
export { ForwardRef as ReactComponent };